/*
 * @Author: YuanYuan
 * @Date: 2024-02-07 16:16:44
 * @LastEditTime: 2025-12-12 17:14:03
 * @description: 现金账户收支记录路由定义
 */
import i18n from '@/i18n'

export default [
  {
    path: '/transactions',
    meta: {
      title: i18n.t('menu.transactionRecord'),
      leftMenuCode: 'Bills'
    },
    component: () => import('@/views/transactions/index.vue')
  }
]
